<template>
  <v-card outlined>
    <v-card-title>{{ `${$t('sod.ttl.duty')} ${$t('common.define')}` }}</v-card-title>
    <v-card-text class="pa-2 pt-0">
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="2"><p class="label">{{ `${$t('sod.ttl.duty')} ${$t('sod.ttl.nm')}` }}</p></v-col>
        <v-col cols="10"><v-text-field v-model="item.dutyNm" outlined dense hide-details/></v-col>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="2"><p class="label">{{ `${$t('sod.ttl.duty')} ${$t('sod.ttl.desc')}` }}</p></v-col>
        <v-col cols="10"><v-text-field v-model="item.dutyDesc" outlined dense hide-details/></v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="mr-2" :disabled="!isSavable" small color="primary" @click="saveDuty">{{ $t('common.save') }}</v-btn>
      <v-btn class="mr-2" small color="primary" @click="cancelDuty">{{ $t('common.cancel') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { isEmpty } from 'lodash';
import { api } from '@/api/common/instances';

export default {
  props: {
    dutyId: {
      type: Number,
    },
  },
  data() {
    return {
      item: {
        dutyNm: '',
        dutyDesc: '',
      },
    };
  },
  computed: {
    isSavable() {
      return !isEmpty(this.item.dutyNm);
    },
  },
  watch: {
    dutyId: {
      handler(val) {
        if (val == 0) this.item = {};
        else this.fetchDuty();
      },
    },
  },
  methods: {
    async saveDuty() {
      if (await this.$dialog.confirm(this.$t('common.save.q'))) {
        const { status } = await api.post('/sod/duty', this.item);
        if (status === 200) {
          this.$snackbar(this.$t('common.successful'));
          this.$emit('close', 'save');
          this.item = {};
        }
      }
    },
    cancelDuty() {
      this.$emit('close', 'cancel');
      this.item = {};
    },
    async fetchDuty() {
      const params = { dutyId: this.dutyId };
      const { data: item } = await api.get('/sod/duty', { params });
      this.item = item;
    },
  },
};
</script>

<style scoped>
.label {
  text-align: right;
  padding: 4px 15px 0px 0px;
}
.v-text-field {
  width: 100%;
}
</style>
